export default __webpack_public_path__ + "static/media/mostPopular.942f3637.png";